/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    container: {
      backgroundColor: `${colors.primaryDark}44`, // @TODO: abstract with other widgets
    },
    verseWrapper: {
      display: 'flex',
      paddingTop: 8,
    },
    passageOfTheDayTitle: {
      fontSize: globalScale * 18,
      color: colors.white,
      fontFamily: fonts.primaryBold,
      textAlign: 'center',
      alignSelf: 'center',
      paddingTop: globalScale * 4,
      paddingBottom: globalScale * 8,
    },
    passageDisplayOverrides: {
      paddingHorizontal: 0,
      paddingTop: 4,
      paddingBottom: 4,
    },
    passageOfTheDayActions: { // @TODO: make more general and share (make part of listitem and toggle background color and border with prop)
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: `${colors.primaryDark}44`, // @TODO: abstract with friends widget
      borderRadius: 8,
      padding: 0,
      margin: 4,
    },
    passageOfTheDayAction: {
      margin: 0,
      // @TODO: backgroundColor: colors.primary,
    },
    sectionWrapperTODO: { // @TODO: in the dialog...could probably be in commonStyles @TODO: abstract this and below with Settings/styles.native.js ()
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: globalScale * 8, // @TODO: don't need this for licensing info dialog
    },
    sectionTitleTODO: { // @TODO: in the dialog...could probably be in commonStyles
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    checkAndTitle: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    descriptionText: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.white : colors.black,
    },
    actionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      marginTop: 4,
    },
    timeText: {
      color: isDarkMode ? colors.lightGray : colors.gray,
    },
    timeDisplay: {
      borderBottomWidth: 1,
      borderColor: isDarkMode ? colors.primaryExtraLight : colors.primaryLight,
    },
    time: {
      color: isDarkMode ? colors.primaryExtraLight : colors.primary,
    },
  };
};

export default getStyles;
